export default __webpack_public_path__ + "static/media/ryba.84ea0513.svg";